import { SearchResult } from 'app/concierge/types';
import { Box, Stack, Tooltip } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import React, { useMemo } from 'react';
import useBundleTranslation from 'i18n';
import { openInNewTab } from 'tools/tools';
import { ICustomStyles } from 'app/concierge/panel';
import defaultStyles from '../styles';
import { useSelector } from 'react-redux';
import { merge } from 'lodash';
import { dispatchCustomEvent } from 'tools/events';

export default function DatasetDataResultItem({ result }: { result: SearchResult }) {
    const { t } = useBundleTranslation(['app/concierge/widget']);
    const customStyles = useSelector((state: any) => state.concierge.customStyles) as ICustomStyles;

    const styles = useMemo(() => {
        return merge({}, defaultStyles, { item: customStyles?.activeChatMessageResultItem }) as typeof defaultStyles;
    }, [customStyles]);

    const iconName = result.icon_type || result.content_type || result.external_tool_type || '';
    const description = result.description ?? null;
    const isAppPanel = useSelector((state: any) => state.concierge.isAppPanel) as boolean;

    const hasUrl = result.url || result.external_link;
    const rawToolName = hasUrl ? result.content_type : result.external_tool_type;
    const toolName = rawToolName ? rawToolName.charAt(0).toUpperCase() + rawToolName.slice(1) : '';

    const onItemClick = async () => {
        if (isAppPanel) {
            dispatchCustomEvent('mi-concierge-panel', {
                action: 'item-click',
                payload: {
                    item: result,
                },
            });
        } else {
            const url = result.url || result.external_link || result.external_tool_url || null;

            if (url) {
                openInNewTab(url);
            }
        }
    };

    const getName = () => {
        return (
            <Tooltip
                title={
                    <Stack direction={'row'} spacing={1} onClick={() => onItemClick()}>
                        <Box sx={styles.link}>
                            {toolName.length > 0
                                ? t('message.open_in', { source: toolName })
                                : t('message.open_in_new_tab')}
                        </Box>
                        <Box sx={styles.link}>
                            <IconMi sx={{ fontSize: 16 }} icon={'external-link'} />
                        </Box>
                    </Stack>
                }
                placement={'top'}
            >
                <Box sx={styles.link} onClick={() => onItemClick()}>
                    {result.name}
                </Box>
            </Tooltip>
        );
    };

    const icon =
        iconName.length > 0 ? (
            <Box>
                <img
                    src={`${window.location.origin}/data/content/index/default-icon/type/${iconName}`}
                    alt={''}
                    height={16}
                    width={16}
                />
            </Box>
        ) : (
            <IconMi name={'datasets'} />
        );

    return (
        <Stack sx={styles.item} key={result.id}>
            <Stack direction={'row'} spacing={1}>
                <Box>{icon}</Box>
                {getName()}
            </Stack>
            {description && <Box sx={styles.description}>{description}</Box>}
        </Stack>
    );
}
